"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Table = function Table(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row column expanded"
  }, /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("tbody", null, data.map(function (row, ix) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: ix
    }, row.map(function (el, jx) {
      return /*#__PURE__*/_react["default"].createElement("td", {
        key: jx
      }, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: el
        }
      }));
    }));
  }))));
};

Table.propTypes = {
  data: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].string)).isRequired
};
var _default = Table;
exports["default"] = _default;